import { Parents, Elements, Element, HistoryMap, ElementIds, ExhaustedState } from 'types';
import { createParentsKey } from 'helpers/history';

const areMixed = (history: HistoryMap, parents: Parents) => {
  const key = createParentsKey(parents);
  return history.hasOwnProperty(key);
};

export const hasUndiscoveredConnections =
(elements: Elements, history: HistoryMap, elementId: Element['id']) => {
  const children = elements[elementId].children;
  const hasUndiscovered = children.some((id) => {
    const element = elements[id];
    // eslint-disable-next-line
    for (const parents of element.parents) {
      // if element is one of parents then check if already discovered
      if (elementId === parents[0] || elementId === parents[1]) {
        const discovered = areMixed(history, parents);

        // if not discovered then element is not exhausted
        if (!discovered) {
          return true;
        }
      }
    }

    return false;
  });

  return hasUndiscovered;
};

export const isElementExhausted = (elements: Elements, history: HistoryMap, rawId: Element['id']) => {
  const elementId = `${ rawId }`;
  return !hasUndiscoveredConnections(elements, history, elementId);
};

export const getElementsExhaustedState =
(elements: Elements, history: HistoryMap, ids: ElementIds): ExhaustedState[] =>
  ids.map((id) => ({ id, exhausted: isElementExhausted(elements, history, id) }));
